import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg col-6 pe-0 mb-1" }
const _hoisted_3 = { class: "col-lg col-6 pe-0 mb-1" }
const _hoisted_4 = { class: "col-lg col-6 pe-0 mb-1" }
const _hoisted_5 = { class: "col-lg col-6 pe-0 mb-1" }
const _hoisted_6 = { class: "col-lg col-6 pe-0 mb-1" }
const _hoisted_7 = { class: "col-lg col-6 pe-0 mb-1" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-6 col-lg-auto text-nowrap" }

import { reactive, onMounted, ref, computed, nextTick } from "vue";

/* serviços */
import * as service from "@/services/BoletosService";
import { addDays, fdata, f2dec, fdataHora, salvarFiltros, carregarFiltros } from "@/utils/funcoes";

/* componentes */
import TextBox from "@/components/TextBox/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Pesquisa',
  emits: ["onPesquisar"],
  setup(__props, { emit: __emit }) {


/* Vue */
var exibirFiltros = ref(false);

var controle = reactive({
    filtros: {
        statusId: 1,
        paginaAtual: 1,
        tamanhoPagina: 500 
    } as service.BoletoFiltros
});

var interno = reactive({
    status: [] as Array<service.EnumModel>,
    ocorrencias: [] as Array<service.EnumModel>,
})

let tempoEsperaPesquisa = 0 as ReturnType<typeof setTimeout> | number;

const emit = __emit;

const disparar = () => {
    emit("onPesquisar", controle.filtros);
    salvarFiltros("boletosFiltros", controle.filtros);
}

const preparaPesquisa = () => {
    clearTimeout(tempoEsperaPesquisa);
    tempoEsperaPesquisa = setTimeout(disparar, 700);
}

const selecAll = (event: any) => {
    event.target.select();
}


const inputFocus = ref(null) as any;

onMounted(() => {

    

    setTimeout(() => {

        var filtros = carregarFiltros("boletosFiltros");

        if (filtros)
            controle.filtros = filtros;

         service.obterOpcoes().then( r => {
            console.log("obtendo opções", r);
            interno.status = r.status;
            interno.ocorrencias = r.ocorrenciasRemessa;
        })

        disparar();

        var el = document.getElementById("inputFocus");
        if (el != null && el != undefined)
            el.focus();

    }, 100);
})

function limparFiltros() {
    controle.filtros.boletoId = null;
    controle.filtros.clienteId = null;
    controle.filtros.dataVencIni = null;
    controle.filtros.dataVencFim = null;
    controle.filtros.statusIds = null;
    controle.filtros.nossoNumero = null;
    controle.filtros.pedidoId = null;
    controle.filtros.dataCadIni = null;
    controle.filtros.dataCadFim = null;
    controle.filtros.dataDocIni = null;
    controle.filtros.dataDocFim = null;

    nextTick(() => {
        disparar();
        inputFocus.value?.focus();
    })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TrataTecla, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[9] || (_cache[9] = _createElementVNode("label", null, "Pesquisar", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control-sm",
            placeholder: "Pesquisar Cliente, Nome",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).filtros.nome) = $event)),
            onKeyup: preparaPesquisa,
            onFocus: selecAll,
            ref_key: "inputFocus",
            ref: inputFocus,
            id: "inputFocus"
          }, null, 544), [
            [_vModelText, _unref(controle).filtros.nome]
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[10] || (_cache[10] = _createElementVNode("label", null, "Dt. Emissão Ini", -1)),
          _createVNode(TextBox, {
            formato: 'Data',
            class: "form-control form-control-sm",
            id: "dataCadIni",
            modelValue: _unref(controle).filtros.dataCadIni,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(controle).filtros.dataCadIni) = $event)),
            onAlteraValor: preparaPesquisa
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[11] || (_cache[11] = _createElementVNode("label", null, "Dt. Emissão Fin", -1)),
          _createVNode(TextBox, {
            formato: 'Data',
            class: "form-control form-control-sm",
            id: "dataCadFim",
            modelValue: _unref(controle).filtros.dataCadFim,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).filtros.dataCadFim) = $event)),
            onAlteraValor: preparaPesquisa
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[12] || (_cache[12] = _createElementVNode("label", null, "Dt Docto Ini", -1)),
          _createVNode(TextBox, {
            formato: 'Data',
            class: "form-control form-control-sm",
            id: "dataDocIni",
            modelValue: _unref(controle).filtros.dataDocIni,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(controle).filtros.dataDocIni) = $event)),
            onAlteraValor: preparaPesquisa
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[13] || (_cache[13] = _createElementVNode("label", null, "Dt Docto Fin", -1)),
          _createVNode(TextBox, {
            formato: 'Data',
            class: "form-control form-control-sm",
            id: "dataDocFim",
            modelValue: _unref(controle).filtros.dataDocFim,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(controle).filtros.dataDocFim) = $event)),
            onAlteraValor: preparaPesquisa
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[15] || (_cache[15] = _createElementVNode("label", null, "Status", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(controle).filtros.statusId) = $event)),
            class: "form-select form-select-sm",
            onChange: _cache[6] || (_cache[6] = ($event: any) => (disparar()))
          }, [
            _cache[14] || (_cache[14] = _createElementVNode("option", { value: null }, "Todos", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(interno).status, (item, idx) => {
              return (_openBlock(), _createElementBlock("option", {
                key: idx,
                value: item.posicao
              }, _toDisplayString(item.texto), 9, _hoisted_8))
            }), 128))
          ], 544), [
            [_vModelSelect, _unref(controle).filtros.statusId]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("a", {
            class: "btn btn-primary btn-sm me-1 mt-3",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (disparar())),
            title: "Atualizar busca"
          }, [...(_cache[16] || (_cache[16] = [
            _createElementVNode("i", { class: "flaticon-search" }, null, -1)
          ]))]),
          _createElementVNode("a", {
            class: "btn btn-primary btn-sm me-1 mt-3",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (limparFiltros())),
            title: "Limpar os filtros"
          }, [...(_cache[17] || (_cache[17] = [
            _createElementVNode("i", { class: "flaticon-close" }, null, -1)
          ]))])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})